import { useState } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { AddIcon } from "@l2r-front/l2r-icons"
import { useNetworksStateContext, useRoleIsReadOnly } from "@l2r-front/l2r-networks"
import { API_MODULE_CAMPAIGN, I18N_NAMESPACE } from "@l2r-front/l2r-shared-campaign"
import { MoreButton } from "@l2r-front/l2r-ui"

import { CampaignCreateModal } from "../CampaignCreateModal"
import { CampaignSidebarContent } from "../CampaignSidebarContent"

import * as Styled from "./CampaignSidebar.styled"

export function CampaignSidebar() {

    const { t } = useTranslation([I18N_NAMESPACE])
    const [createModalOpen, setCreateModalOpen] = useState(false)
    const { selectedNetwork } = useNetworksStateContext()
    const readOnly = useRoleIsReadOnly(selectedNetwork?.sub_networks, API_MODULE_CAMPAIGN)

    return (
        <Styled.BottomSheetContent
            id="campaign-sidebar"
            title={t(I18N_NAMESPACE, "containers.campaignSidebar.title")}
            titleSideComponent={!readOnly && <MoreButton
                color="primary"
                icon={AddIcon}
                size={"small"}
                onClick={() => setCreateModalOpen(true)} />
            }
        >
            <CampaignSidebarContent />
            <CampaignCreateModal open={createModalOpen} onClose={() => setCreateModalOpen(false)} />
        </Styled.BottomSheetContent>
    )
}
